export default __webpack_public_path__ + "static/0195-447f2181976c9ba81a3716155df73537.png";